"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ravenna": {
    "b7a0df59": [{
      "hkey": "889bee52",
      "slug": "agrario-fornace-zarattini",
      "name": "Agrario-Fornace Zarattini",
      "primary": true,
      "skipSearch": false
    }],
    "agrario": [{
      "hkey": "889bee52",
      "slug": "agrario-fornace-zarattini",
      "name": "Agrario-Fornace Zarattini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "197e5860": [{
      "hkey": "01d86af6",
      "slug": "mezzano-ammonite-savarna",
      "name": "Mezzano-Ammonite-Savarna",
      "primary": true,
      "skipSearch": false
    }],
    "ammonite": [{
      "hkey": "01d86af6",
      "slug": "mezzano-ammonite-savarna",
      "name": "Mezzano-Ammonite-Savarna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ravenna"
    }],
    "abef1642": [{
      "hkey": "3a4453a1",
      "slug": "bassette-porto",
      "name": "Bassette-Porto",
      "primary": true,
      "skipSearch": false
    }],
    "bassette": [{
      "hkey": "3a4453a1",
      "slug": "bassette-porto",
      "name": "Bassette-Porto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "76e87732": [{
      "hkey": "23f203a0",
      "slug": "fosso-ghiaia-borgo-faina",
      "name": "Fosso Ghiaia-Borgo Faina",
      "primary": true,
      "skipSearch": false
    }],
    "borgo-faina": [{
      "hkey": "23f203a0",
      "slug": "fosso-ghiaia-borgo-faina",
      "name": "Fosso Ghiaia-Borgo Faina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b35888da": [{
      "hkey": "2a58ef37",
      "slug": "ravenna",
      "name": "Ravenna",
      "primary": true,
      "skipSearch": false
    }],
    "borgo-garibaldi": [{
      "hkey": "2a58ef37",
      "slug": "ravenna",
      "name": "Ravenna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9231b0d0": [{
      "hkey": "7a0757f0",
      "slug": "borgo-nuovo",
      "name": "Borgo Nuovo",
      "primary": true,
      "skipSearch": false
    }],
    "borgo-nuovo": [{
      "hkey": "7a0757f0",
      "slug": "borgo-nuovo",
      "name": "Borgo Nuovo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "centro-citta"
    }],
    "6e5b2486": [{
      "hkey": "60647f7c",
      "slug": "ospedale-stadio-tribunale",
      "name": "Ospedale-Stadio-Tribunale",
      "primary": true,
      "skipSearch": false
    }],
    "bosco-baronio": [{
      "hkey": "60647f7c",
      "slug": "ospedale-stadio-tribunale",
      "name": "Ospedale-Stadio-Tribunale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "centro-citta"
    }],
    "b248ca47": [{
      "hkey": "478c4941",
      "slug": "camerlona-piangipane-san-michele-santerno",
      "name": "Camerlona-Piangipane-San Michele-Santerno",
      "primary": true,
      "skipSearch": false
    }],
    "camerlona": [{
      "hkey": "478c4941",
      "slug": "camerlona-piangipane-san-michele-santerno",
      "name": "Camerlona-Piangipane-San Michele-Santerno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6967e0ce": [{
      "hkey": "78ce0cc9",
      "slug": "campiano-san-pietro-in-campiano",
      "name": "Campiano-San Pietro in Campiano",
      "primary": true,
      "skipSearch": false
    }],
    "campiano": [{
      "hkey": "78ce0cc9",
      "slug": "campiano-san-pietro-in-campiano",
      "name": "Campiano-San Pietro in Campiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "san-pietro-in-vincoli-gambellara"
    }],
    "3efa512c": [{
      "hkey": "771d9a8d",
      "slug": "carraie-santo-stefano",
      "name": "Carraie-Santo Stefano",
      "primary": true,
      "skipSearch": false
    }],
    "carraie": [{
      "hkey": "771d9a8d",
      "slug": "carraie-santo-stefano",
      "name": "Carraie-Santo Stefano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "san-pietro-in-vincoli-gambellara"
    }],
    "9589ac77": [{
      "hkey": "e1d1abc9",
      "slug": "casalborsetti-marina-romea-porto-corsini",
      "name": "Casalborsetti-Marina Romea-Porto Corsini",
      "primary": true,
      "skipSearch": false
    }],
    "casal-borsetti": [{
      "hkey": "e1d1abc9",
      "slug": "casalborsetti-marina-romea-porto-corsini",
      "name": "Casalborsetti-Marina Romea-Porto Corsini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "1067468a": [{
      "hkey": "d9c09e70",
      "slug": "castiglione-san-zaccaria-casemurate",
      "name": "Castiglione-San Zaccaria-Casemurate",
      "primary": true,
      "skipSearch": false
    }],
    "casemurate": [{
      "hkey": "d9c09e70",
      "slug": "castiglione-san-zaccaria-casemurate",
      "name": "Castiglione-San Zaccaria-Casemurate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ravenna"
    }],
    "fc536657": [{
      "hkey": "2a58ef37",
      "slug": "ravenna",
      "name": "Ravenna",
      "primary": true,
      "skipSearch": false
    }],
    "castiglione-di-cervia": [{
      "hkey": "2a58ef37",
      "slug": "ravenna",
      "name": "Ravenna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1996183b": [{
      "hkey": "d9c09e70",
      "slug": "castiglione-san-zaccaria-casemurate",
      "name": "Castiglione-San Zaccaria-Casemurate",
      "primary": true,
      "skipSearch": false
    }],
    "castiglione-di-ravenna": [{
      "hkey": "d9c09e70",
      "slug": "castiglione-san-zaccaria-casemurate",
      "name": "Castiglione-San Zaccaria-Casemurate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "cc7d8ea3": [{
      "hkey": "51f6d188",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "skipSearch": false
    }],
    "centro-storico": [{
      "hkey": "51f6d188",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "centro-citta"
    }],
    "6e510622": [{
      "hkey": "ab671615",
      "slug": "san-giuseppe-teodorico",
      "name": "San Giuseppe-Teodorico",
      "primary": true,
      "skipSearch": false
    }],
    "chiavica-romea": [{
      "hkey": "ab671615",
      "slug": "san-giuseppe-teodorico",
      "name": "San Giuseppe-Teodorico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "centro-citta"
    }],
    "5cfe6638": [{
      "hkey": "60c8acfc",
      "slug": "centro-citta",
      "name": "Centro Città",
      "primary": true,
      "skipSearch": false
    }],
    "cintura-centro": [{
      "hkey": "60c8acfc",
      "slug": "centro-citta",
      "name": "Centro Città",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ravenna"
    }],
    "01958ada": [{
      "hkey": "30fb9f42",
      "slug": "coccolia",
      "name": "Coccolia",
      "primary": true,
      "skipSearch": false
    }],
    "coccolia": [{
      "hkey": "30fb9f42",
      "slug": "coccolia",
      "name": "Coccolia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "roncalceci-coccolia-san-pietro-in-trento"
    }],
    "11b304a2": [{
      "hkey": "01d86af6",
      "slug": "mezzano-ammonite-savarna",
      "name": "Mezzano-Ammonite-Savarna",
      "primary": true,
      "skipSearch": false
    }],
    "conventello": [{
      "hkey": "01d86af6",
      "slug": "mezzano-ammonite-savarna",
      "name": "Mezzano-Ammonite-Savarna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ravenna"
    }],
    "d1fa29e6": [{
      "hkey": "35f6906b",
      "slug": "darsena",
      "name": "Darsena",
      "primary": true,
      "skipSearch": false
    }],
    "darsena": [{
      "hkey": "35f6906b",
      "slug": "darsena",
      "name": "Darsena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "centro-citta"
    }],
    "ead7a6e3": [{
      "hkey": "2a58ef37",
      "slug": "ravenna",
      "name": "Ravenna",
      "primary": true,
      "skipSearch": false
    }],
    "faenza-centro": [{
      "hkey": "2a58ef37",
      "slug": "ravenna",
      "name": "Ravenna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "139dfcc3": [{
      "hkey": "2a58ef37",
      "slug": "ravenna",
      "name": "Ravenna",
      "primary": true,
      "skipSearch": false
    }],
    "faenza-periferia": [{
      "hkey": "2a58ef37",
      "slug": "ravenna",
      "name": "Ravenna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "94fd0cb6": [{
      "hkey": "2a58ef37",
      "slug": "ravenna",
      "name": "Ravenna",
      "primary": true,
      "skipSearch": false
    }],
    "faenza-semicentro": [{
      "hkey": "2a58ef37",
      "slug": "ravenna",
      "name": "Ravenna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bee52335": [{
      "hkey": "f61618ff",
      "slug": "filetto-pilastro",
      "name": "Filetto-Pilastro",
      "primary": true,
      "skipSearch": false
    }],
    "filetto": [{
      "hkey": "f61618ff",
      "slug": "filetto-pilastro",
      "name": "Filetto-Pilastro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "roncalceci-coccolia-san-pietro-in-trento"
    }],
    "a2fca4b4": [{
      "hkey": "889bee52",
      "slug": "agrario-fornace-zarattini",
      "name": "Agrario-Fornace Zarattini",
      "primary": true,
      "skipSearch": false
    }],
    "fornace-zarattini": [{
      "hkey": "889bee52",
      "slug": "agrario-fornace-zarattini",
      "name": "Agrario-Fornace Zarattini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ravenna"
    }],
    "f9ddd225": [{
      "hkey": "23f203a0",
      "slug": "fosso-ghiaia-borgo-faina",
      "name": "Fosso Ghiaia-Borgo Faina",
      "primary": true,
      "skipSearch": false
    }],
    "fosso-ghiaia": [{
      "hkey": "23f203a0",
      "slug": "fosso-ghiaia-borgo-faina",
      "name": "Fosso Ghiaia-Borgo Faina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ravenna"
    }],
    "7a008bbf": [{
      "hkey": "dfac0f26",
      "slug": "galilei-viale-alberti",
      "name": "Galilei-Viale Alberti",
      "primary": true,
      "skipSearch": false
    }],
    "galilei": [{
      "hkey": "dfac0f26",
      "slug": "galilei-viale-alberti",
      "name": "Galilei-Viale Alberti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "centro-citta"
    }],
    "be454fc7": [{
      "hkey": "5ae35c65",
      "slug": "gallery-via-rubicone",
      "name": "Gallery-Via Rubicone",
      "primary": true,
      "skipSearch": false
    }],
    "gallery": [{
      "hkey": "5ae35c65",
      "slug": "gallery-via-rubicone",
      "name": "Gallery-Via Rubicone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "centro-citta"
    }],
    "0f3386dc": [{
      "hkey": "2c4fe710",
      "slug": "gambellara",
      "name": "Gambellara",
      "primary": true,
      "skipSearch": false
    }],
    "gambellara": [{
      "hkey": "2c4fe710",
      "slug": "gambellara",
      "name": "Gambellara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "san-pietro-in-vincoli-gambellara"
    }],
    "c8d1128e": [{
      "hkey": "af4e5efd",
      "slug": "ghibullo",
      "name": "Ghibullo",
      "primary": true,
      "skipSearch": false
    }],
    "ghibullo": [{
      "hkey": "af4e5efd",
      "slug": "ghibullo",
      "name": "Ghibullo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "roncalceci-coccolia-san-pietro-in-trento"
    }],
    "1c33ce51": [{
      "hkey": "2a58ef37",
      "slug": "ravenna",
      "name": "Ravenna",
      "primary": true,
      "skipSearch": false
    }],
    "glorie-di-mezzano": [{
      "hkey": "2a58ef37",
      "slug": "ravenna",
      "name": "Ravenna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e55b3241": [{
      "hkey": "2a58ef37",
      "slug": "ravenna",
      "name": "Ravenna",
      "primary": true,
      "skipSearch": false
    }],
    "godo": [{
      "hkey": "2a58ef37",
      "slug": "ravenna",
      "name": "Ravenna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e0ae6a3f": [{
      "hkey": "75ad590b",
      "slug": "lido-adriano",
      "name": "Lido Adriano",
      "primary": true,
      "skipSearch": false
    }],
    "lido-adriano": [{
      "hkey": "75ad590b",
      "slug": "lido-adriano",
      "name": "Lido Adriano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "lidi-savio"
    }],
    "344e69a2": [{
      "hkey": "d46a54bb",
      "slug": "lido-di-classe",
      "name": "Lido di Classe",
      "primary": true,
      "skipSearch": false
    }],
    "lido-di-classe": [{
      "hkey": "d46a54bb",
      "slug": "lido-di-classe",
      "name": "Lido di Classe",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "lidi-savio"
    }],
    "662a549b": [{
      "hkey": "01e159a6",
      "slug": "lido-di-dante",
      "name": "Lido di Dante",
      "primary": true,
      "skipSearch": false
    }],
    "lido-di-dante": [{
      "hkey": "01e159a6",
      "slug": "lido-di-dante",
      "name": "Lido di Dante",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "lidi-savio"
    }],
    "558d88e9": [{
      "hkey": "2a58ef37",
      "slug": "ravenna",
      "name": "Ravenna",
      "primary": true,
      "skipSearch": false
    }],
    "lido-di-magnavacca": [{
      "hkey": "2a58ef37",
      "slug": "ravenna",
      "name": "Ravenna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a70d5f75": [{
      "hkey": "18a1a581",
      "slug": "lido-di-savio",
      "name": "Lido di Savio",
      "primary": true,
      "skipSearch": false
    }],
    "lido-di-savio": [{
      "hkey": "18a1a581",
      "slug": "lido-di-savio",
      "name": "Lido di Savio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "lidi-savio"
    }],
    "8ab649da": [{
      "hkey": "a856b22a",
      "slug": "longana",
      "name": "Longana",
      "primary": true,
      "skipSearch": false
    }],
    "longana": [{
      "hkey": "a856b22a",
      "slug": "longana",
      "name": "Longana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "roncalceci-coccolia-san-pietro-in-trento"
    }],
    "8865e59e": [{
      "hkey": "4d56018c",
      "slug": "sant-alberto-mandriole",
      "name": "Sant'Alberto-Mandriole",
      "primary": true,
      "skipSearch": false
    }],
    "mandriole": [{
      "hkey": "4d56018c",
      "slug": "sant-alberto-mandriole",
      "name": "Sant'Alberto-Mandriole",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ravenna"
    }],
    "ed192367": [{
      "hkey": "cb681c4d",
      "slug": "marina-di-ravenna-punta-marina",
      "name": "Marina di Ravenna-Punta Marina",
      "primary": true,
      "skipSearch": false
    }],
    "marina-di-ravenna": [{
      "hkey": "cb681c4d",
      "slug": "marina-di-ravenna-punta-marina",
      "name": "Marina di Ravenna-Punta Marina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "144d2052": [{
      "hkey": "e1d1abc9",
      "slug": "casalborsetti-marina-romea-porto-corsini",
      "name": "Casalborsetti-Marina Romea-Porto Corsini",
      "primary": true,
      "skipSearch": false
    }],
    "marina-romea": [{
      "hkey": "e1d1abc9",
      "slug": "casalborsetti-marina-romea-porto-corsini",
      "name": "Casalborsetti-Marina Romea-Porto Corsini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ravenna"
    }],
    "8d65492c": [{
      "hkey": "01d86af6",
      "slug": "mezzano-ammonite-savarna",
      "name": "Mezzano-Ammonite-Savarna",
      "primary": true,
      "skipSearch": false
    }],
    "mezzano": [{
      "hkey": "01d86af6",
      "slug": "mezzano-ammonite-savarna",
      "name": "Mezzano-Ammonite-Savarna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "63a079bb": [{
      "hkey": "35f6906b",
      "slug": "darsena",
      "name": "Darsena",
      "primary": true,
      "skipSearch": false
    }],
    "molinetto": [{
      "hkey": "35f6906b",
      "slug": "darsena",
      "name": "Darsena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "centro-citta"
    }],
    "9393cb9c": [{
      "hkey": "372154ef",
      "slug": "vicoli",
      "name": "Vicoli",
      "primary": true,
      "skipSearch": false
    }],
    "nullo-baldini": [{
      "hkey": "372154ef",
      "slug": "vicoli",
      "name": "Vicoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "centro-citta"
    }],
    "c37861c4": [{
      "hkey": "60647f7c",
      "slug": "ospedale-stadio-tribunale",
      "name": "Ospedale-Stadio-Tribunale",
      "primary": true,
      "skipSearch": false
    }],
    "ospedale": [{
      "hkey": "60647f7c",
      "slug": "ospedale-stadio-tribunale",
      "name": "Ospedale-Stadio-Tribunale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "centro-citta"
    }],
    "f274bf02": [{
      "hkey": "d85a4a77",
      "slug": "osteria",
      "name": "Osteria",
      "primary": true,
      "skipSearch": false
    }],
    "osteria": [{
      "hkey": "d85a4a77",
      "slug": "osteria",
      "name": "Osteria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "san-pietro-in-vincoli-gambellara"
    }],
    "3655d047": [{
      "hkey": "e1d1abc9",
      "slug": "casalborsetti-marina-romea-porto-corsini",
      "name": "Casalborsetti-Marina Romea-Porto Corsini",
      "primary": true,
      "skipSearch": false
    }],
    "pialassa-baiona": [{
      "hkey": "e1d1abc9",
      "slug": "casalborsetti-marina-romea-porto-corsini",
      "name": "Casalborsetti-Marina Romea-Porto Corsini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ravenna"
    }],
    "893ed87c": [{
      "hkey": "3a4453a1",
      "slug": "bassette-porto",
      "name": "Bassette-Porto",
      "primary": true,
      "skipSearch": false
    }],
    "pialassa-piombone": [{
      "hkey": "3a4453a1",
      "slug": "bassette-porto",
      "name": "Bassette-Porto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ravenna"
    }],
    "2b13bd42": [{
      "hkey": "478c4941",
      "slug": "camerlona-piangipane-san-michele-santerno",
      "name": "Camerlona-Piangipane-San Michele-Santerno",
      "primary": true,
      "skipSearch": false
    }],
    "piangipane": [{
      "hkey": "478c4941",
      "slug": "camerlona-piangipane-san-michele-santerno",
      "name": "Camerlona-Piangipane-San Michele-Santerno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ravenna"
    }],
    "8646986d": [{
      "hkey": "f61618ff",
      "slug": "filetto-pilastro",
      "name": "Filetto-Pilastro",
      "primary": true,
      "skipSearch": false
    }],
    "pilastro": [{
      "hkey": "f61618ff",
      "slug": "filetto-pilastro",
      "name": "Filetto-Pilastro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "roncalceci-coccolia-san-pietro-in-trento"
    }],
    "bc2db1f0": [{
      "hkey": "e1d1abc9",
      "slug": "casalborsetti-marina-romea-porto-corsini",
      "name": "Casalborsetti-Marina Romea-Porto Corsini",
      "primary": true,
      "skipSearch": false
    }],
    "pineta-san-vitale": [{
      "hkey": "e1d1abc9",
      "slug": "casalborsetti-marina-romea-porto-corsini",
      "name": "Casalborsetti-Marina Romea-Porto Corsini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ravenna"
    }],
    "c36e59e2": [{
      "hkey": "1a04228a",
      "slug": "ponte-nuovo",
      "name": "Ponte Nuovo",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-nuovo-classe-madonna-dell-albero-san-bartolo": [{
      "hkey": "1a04228a",
      "slug": "ponte-nuovo",
      "name": "Ponte Nuovo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ravenna"
    }],
    "c44e85a7": [{
      "hkey": "e1d1abc9",
      "slug": "casalborsetti-marina-romea-porto-corsini",
      "name": "Casalborsetti-Marina Romea-Porto Corsini",
      "primary": true,
      "skipSearch": false
    }],
    "porto-corsini": [{
      "hkey": "e1d1abc9",
      "slug": "casalborsetti-marina-romea-porto-corsini",
      "name": "Casalborsetti-Marina Romea-Porto Corsini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ravenna"
    }],
    "ef23edf9": [{
      "hkey": "6d697a47",
      "slug": "classe-porto-fuori",
      "name": "Classe-Porto Fuori",
      "primary": true,
      "skipSearch": false
    }],
    "porto-fuori": [{
      "hkey": "6d697a47",
      "slug": "classe-porto-fuori",
      "name": "Classe-Porto Fuori",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e4010cfe": [{
      "hkey": "cb681c4d",
      "slug": "marina-di-ravenna-punta-marina",
      "name": "Marina di Ravenna-Punta Marina",
      "primary": true,
      "skipSearch": false
    }],
    "punta-marina": [{
      "hkey": "cb681c4d",
      "slug": "marina-di-ravenna-punta-marina",
      "name": "Marina di Ravenna-Punta Marina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ravenna"
    }],
    "627949d8": [{
      "hkey": "e557497a",
      "slug": "ragone",
      "name": "Ragone",
      "primary": true,
      "skipSearch": false
    }],
    "ragone": [{
      "hkey": "e557497a",
      "slug": "ragone",
      "name": "Ragone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "roncalceci-coccolia-san-pietro-in-trento"
    }],
    "15159d51": [{
      "hkey": "60a0e1c4",
      "slug": "madonna-dell-albero-san-bartolo",
      "name": "Madonna dell'Albero-San Bartolo",
      "primary": true,
      "skipSearch": false
    }],
    "ravegnana": [{
      "hkey": "60a0e1c4",
      "slug": "madonna-dell-albero-san-bartolo",
      "name": "Madonna dell'Albero-San Bartolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ravenna"
    }],
    "b5b2eb87": [{
      "hkey": "c935615c",
      "slug": "roncalceci",
      "name": "Roncalceci",
      "primary": true,
      "skipSearch": false
    }],
    "roncalceci": [{
      "hkey": "c935615c",
      "slug": "roncalceci",
      "name": "Roncalceci",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "roncalceci-coccolia-san-pietro-in-trento"
    }],
    "689fa704": [{
      "hkey": "5602a700",
      "slug": "san-biagio",
      "name": "San Biagio",
      "primary": true,
      "skipSearch": false
    }],
    "san-biagio-san-vittore": [{
      "hkey": "5602a700",
      "slug": "san-biagio",
      "name": "San Biagio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "centro-citta"
    }],
    "a50b6381": [{
      "hkey": "ab671615",
      "slug": "san-giuseppe-teodorico",
      "name": "San Giuseppe-Teodorico",
      "primary": true,
      "skipSearch": false
    }],
    "san-giuseppe": [{
      "hkey": "ab671615",
      "slug": "san-giuseppe-teodorico",
      "name": "San Giuseppe-Teodorico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "centro-citta"
    }],
    "d6161206": [{
      "hkey": "d5d19cbc",
      "slug": "villanova-san-marco",
      "name": "Villanova-San Marco",
      "primary": true,
      "skipSearch": false
    }],
    "san-marco": [{
      "hkey": "d5d19cbc",
      "slug": "villanova-san-marco",
      "name": "Villanova-San Marco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ravenna"
    }],
    "43e8ba72": [{
      "hkey": "478c4941",
      "slug": "camerlona-piangipane-san-michele-santerno",
      "name": "Camerlona-Piangipane-San Michele-Santerno",
      "primary": true,
      "skipSearch": false
    }],
    "san-michele": [{
      "hkey": "478c4941",
      "slug": "camerlona-piangipane-san-michele-santerno",
      "name": "Camerlona-Piangipane-San Michele-Santerno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ravenna"
    }],
    "ec76d7ae": [{
      "hkey": "2a58ef37",
      "slug": "ravenna",
      "name": "Ravenna",
      "primary": true,
      "skipSearch": false
    }],
    "san-pancrazio": [{
      "hkey": "2a58ef37",
      "slug": "ravenna",
      "name": "Ravenna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "07d89ffd": [{
      "hkey": "78ce0cc9",
      "slug": "campiano-san-pietro-in-campiano",
      "name": "Campiano-San Pietro in Campiano",
      "primary": true,
      "skipSearch": false
    }],
    "san-pietro-in-campiano": [{
      "hkey": "78ce0cc9",
      "slug": "campiano-san-pietro-in-campiano",
      "name": "Campiano-San Pietro in Campiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "san-pietro-in-vincoli-gambellara"
    }],
    "0cfd1d1f": [{
      "hkey": "7da34746",
      "slug": "san-pietro-in-trento",
      "name": "San Pietro in Trento",
      "primary": true,
      "skipSearch": false
    }],
    "san-pietro-in-trento": [{
      "hkey": "7da34746",
      "slug": "san-pietro-in-trento",
      "name": "San Pietro in Trento",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "roncalceci-coccolia-san-pietro-in-trento"
    }],
    "a13dbc1e": [{
      "hkey": "70cab607",
      "slug": "san-pietro-in-vincoli",
      "name": "San Pietro in Vincoli",
      "primary": true,
      "skipSearch": false
    }],
    "san-pietro-in-vincoli": [{
      "hkey": "70cab607",
      "slug": "san-pietro-in-vincoli",
      "name": "San Pietro in Vincoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "san-pietro-in-vincoli-gambellara"
    }],
    "774a5b63": [{
      "hkey": "2a58ef37",
      "slug": "ravenna",
      "name": "Ravenna",
      "primary": true,
      "skipSearch": false
    }],
    "san-rocco-2": [{
      "hkey": "2a58ef37",
      "slug": "ravenna",
      "name": "Ravenna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e476d3ce": [{
      "hkey": "60c8acfc",
      "slug": "centro-citta",
      "name": "Centro Città",
      "primary": true,
      "skipSearch": false
    }],
    "san-rocco-teodorico": [{
      "hkey": "60c8acfc",
      "slug": "centro-citta",
      "name": "Centro Città",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ravenna"
    }],
    "489e2767": [{
      "hkey": "28483d48",
      "slug": "san-romualdo-sant-antonio",
      "name": "San Romualdo-Sant'Antonio",
      "primary": true,
      "skipSearch": false
    }],
    "san-romualdo": [{
      "hkey": "28483d48",
      "slug": "san-romualdo-sant-antonio",
      "name": "San Romualdo-Sant'Antonio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "db239cbf": [{
      "hkey": "d9c09e70",
      "slug": "castiglione-san-zaccaria-casemurate",
      "name": "Castiglione-San Zaccaria-Casemurate",
      "primary": true,
      "skipSearch": false
    }],
    "san-zaccaria": [{
      "hkey": "d9c09e70",
      "slug": "castiglione-san-zaccaria-casemurate",
      "name": "Castiglione-San Zaccaria-Casemurate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ravenna"
    }],
    "92daea7b": [{
      "hkey": "4d56018c",
      "slug": "sant-alberto-mandriole",
      "name": "Sant'Alberto-Mandriole",
      "primary": true,
      "skipSearch": false
    }],
    "sant-alberto": [{
      "hkey": "4d56018c",
      "slug": "sant-alberto-mandriole",
      "name": "Sant'Alberto-Mandriole",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "54e6b1b1": [{
      "hkey": "28483d48",
      "slug": "san-romualdo-sant-antonio",
      "name": "San Romualdo-Sant'Antonio",
      "primary": true,
      "skipSearch": false
    }],
    "3cdeb9f1": [{
      "hkey": "478c4941",
      "slug": "camerlona-piangipane-san-michele-santerno",
      "name": "Camerlona-Piangipane-San Michele-Santerno",
      "primary": true,
      "skipSearch": false
    }],
    "santerno": [{
      "hkey": "478c4941",
      "slug": "camerlona-piangipane-san-michele-santerno",
      "name": "Camerlona-Piangipane-San Michele-Santerno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ravenna"
    }],
    "6ea53d4d": [{
      "hkey": "771d9a8d",
      "slug": "carraie-santo-stefano",
      "name": "Carraie-Santo Stefano",
      "primary": true,
      "skipSearch": false
    }],
    "santo-stefano": [{
      "hkey": "771d9a8d",
      "slug": "carraie-santo-stefano",
      "name": "Carraie-Santo Stefano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "san-pietro-in-vincoli-gambellara"
    }],
    "7ff59f05": [{
      "hkey": "01d86af6",
      "slug": "mezzano-ammonite-savarna",
      "name": "Mezzano-Ammonite-Savarna",
      "primary": true,
      "skipSearch": false
    }],
    "savarna": [{
      "hkey": "01d86af6",
      "slug": "mezzano-ammonite-savarna",
      "name": "Mezzano-Ammonite-Savarna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ravenna"
    }],
    "1087954d": [{
      "hkey": "12426b89",
      "slug": "lidi-savio",
      "name": "Lidi, Savio",
      "primary": true,
      "skipSearch": false
    }],
    "savio": [{
      "hkey": "12426b89",
      "slug": "lidi-savio",
      "name": "Lidi, Savio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "01de3637": [{
      "hkey": "60647f7c",
      "slug": "ospedale-stadio-tribunale",
      "name": "Ospedale-Stadio-Tribunale",
      "primary": true,
      "skipSearch": false
    }],
    "stadio-tribunale": [{
      "hkey": "60647f7c",
      "slug": "ospedale-stadio-tribunale",
      "name": "Ospedale-Stadio-Tribunale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "centro-citta"
    }],
    "82e5a269": [{
      "hkey": "01d86af6",
      "slug": "mezzano-ammonite-savarna",
      "name": "Mezzano-Ammonite-Savarna",
      "primary": true,
      "skipSearch": false
    }],
    "torri": [{
      "hkey": "01d86af6",
      "slug": "mezzano-ammonite-savarna",
      "name": "Mezzano-Ammonite-Savarna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ravenna"
    }],
    "e9b90e65": [{
      "hkey": "dfac0f26",
      "slug": "galilei-viale-alberti",
      "name": "Galilei-Viale Alberti",
      "primary": true,
      "skipSearch": false
    }],
    "viale-alberti": [{
      "hkey": "dfac0f26",
      "slug": "galilei-viale-alberti",
      "name": "Galilei-Viale Alberti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "centro-citta"
    }],
    "eb2831eb": [{
      "hkey": "3a4453a1",
      "slug": "bassette-porto",
      "name": "Bassette-Porto",
      "primary": true,
      "skipSearch": false
    }],
    "villaggio-anic": [{
      "hkey": "3a4453a1",
      "slug": "bassette-porto",
      "name": "Bassette-Porto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ravenna"
    }],
    "0d90c76b": [{
      "hkey": "d5d19cbc",
      "slug": "villanova-san-marco",
      "name": "Villanova-San Marco",
      "primary": true,
      "skipSearch": false
    }],
    "villanova-di-ravenna": [{
      "hkey": "d5d19cbc",
      "slug": "villanova-san-marco",
      "name": "Villanova-San Marco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;